module.exports = __webpack_public_path__ + "static/eye-7cdf4e8ccad9a2f3dda2921b2a03a2e5.png";